module.exports = __webpack_public_path__ + "assets/svg/Icons/16/task-green-6fa96f.svg";